import React, { Component } from 'react'
import HeaderBlock from '../../Common/HeaderBlock'
import style from './style.module.less'
import { hashHistory } from 'react-router'
import { JIAMENG_CUSTOMER_PATH } from '@constant'

export default class extends Component {
  render() {
    const { title, data, style: styleProp = {} } = this.props

    return (
      <div style={{ ...styleProp }}>
        {/* TODO，使用 panel 组件 */}
        <HeaderBlock title={title}>
          <div className={style.list}>
            {data.map(
              ({ title, value, link, franchise_status, color }, index) => (
                <div
                  className={style.item}
                  key={index}
                  onClick={() => {
                    if (link) {
                      hashHistory.push(link)
                    } else {
                      hashHistory.push({
                        pathname: JIAMENG_CUSTOMER_PATH,
                        query: { franchise_status }
                      })
                    }
                  }}
                >
                  <div className={style.value} style={{ color }}>
                    {value}
                  </div>
                  <div className={style.title}>{title}</div>
                </div>
              )
            )}
          </div>
        </HeaderBlock>
      </div>
    )
  }
}
